import React from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import esLocale from 'date-fns/locale/es';
import { TextField } from "@mui/material";
import "./DateTimePicker.css";

const _DateTimePicker = ({
  dateValue,
  setDateValue,
  label = "Fecha",
  required,
  disabled=false
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
      <DatePicker
        required={required}
        renderInput={(props) => <TextField {...props} />}
        label={label}
        value={dateValue}
        locale="es"
        format="DD-MMM-YYYY"
        onChange={(newValue) => {
          setDateValue(newValue);
        }}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};
export default _DateTimePicker;
